import api from "../../Api";
import { BaseService } from "../../BaseService";

const URL = 'agents/categories/terms';

export class AgentsTermsService extends BaseService {
    async list(params: any): Promise<any[]> {
        try {
            return this.handleResponse(await api.post(`${URL}/list`, params));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }

    async delete(id: number): Promise<any> {
        try {
            return this.handleResponse(await api.delete(`${URL}/delete/${id}`));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }
}